import { AsyncPipe, NgClass } from '@angular/common';
import { Component, computed, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { UrlHelper } from '@ecm/portfolio';
import { LinkService, TrackingData } from '@ecm/router';

import { TrackedNames, TrackedPages, TrackedZones } from '../../business/constants/tracking.constant';
import { CarrouselItemButtonViewModel } from '../../business/model/carrousel-item-button.view-model';
import { CarrouselStoreService } from '../../store/carrousel-store.service';

@Component({
    selector: 'ecm-carrousel-item-new-link',
    templateUrl: './carrousel-item-redirect-link.component.html',
    styleUrls: ['./carrousel-item-redirect-link.component.css'],
    standalone: true,
    imports: [NgClass, AsyncPipe],
})
export class CarrouselItemRedirectLinkComponent implements OnInit {
    public carrouselItemLinkButton: CarrouselItemButtonViewModel;
    public isExternalLink = false;
    public contactInfos = false;
    public hasInvalidContactMeans$ = this.carrouselStore.gethasInvalidContactMeans$;
    public isLoggedWithOpenCaraibe$ = this.carrouselStore.getIsLoggedWithOpenCaraibe$;

    @Input() public type?: string;
    @Input() public selected = false;

    public constructor(
        private readonly translate: TranslateService,
        private linkService: LinkService,
        private carrouselStore: CarrouselStoreService,
    ) {}

    public ngOnInit(): void {
        const carrouselItemLinkTranslation = this.translate.instant(this.type);
        if (this.type.split('.').pop() === 'PERSONAL_INFO') {
            this.contactInfos = true;
        }
        this.carrouselItemLinkButton = {
            label: carrouselItemLinkTranslation.label,
            link: carrouselItemLinkTranslation.link,
            navigationExtras: undefined,
            params: undefined,
            trackingArea: '',
            trackingName: '',
        };

        this.carrouselItemLinkButton.hrefLink = this.linkService.getLinkSync(this.carrouselItemLinkButton.link);
        this.isExternalLink = UrlHelper.isExternalUrl(this.carrouselItemLinkButton.hrefLink);
    }

    public openLink(hrefLink: string, type: string): void {
        const trackingData = new TrackingData();
        trackingData.tmsTracking = {
            trackingArea: TrackedZones.CARE_HP_CARROUSEL,
            trackingName: this.getTrackNames(type),
            targetUrl: hrefLink,
            trackedPage: TrackedPages.DASHBOARD,
        };
        this.linkService.openLink(
            this.carrouselItemLinkButton.link,
            trackingData,
            this.carrouselItemLinkButton.params,
            this.carrouselItemLinkButton.navigationExtras,
        );
    }

    public getTrackNames(type: string): string {
        return TrackedNames[type.split('.').pop()];
    }

    public isEligibleEntryForOpenCaraibe = computed(() => {
        return ['PERSONAL_INFO', 'PROFILS', 'TRACKINGDELIVERY', 'AVANTAGES_CLIENT', 'ORANGE_SERVICES'].includes(
            this.type.split('.').pop(),
        );
    });
}
